<template>
  <base-modal-bottom
    ref="modal"
    class="modal-pix-key-owner-confirmation has-text-centered"
    :isFooter="true"
    :title="title"
    :withClickOverlay="false"
    :btnClose="false"
  >
    <div class="margin-bottom title-message">
      <p>
        <strong>Você está solicitando uma transferência para:</strong>
      </p>
    </div>

    <p class="subtitle-message">
      <strong>{{ pixKey.name }}</strong>
      <br />
      Chave PIX: {{ pixKey.pix_key }}
      <br />
      {{ pixKey.bank_name }}
    </p>

    <template #footer>
      <button class="button button-cancel" @click="cancel">Cancelar</button>
      <button class="button is-primary" @click="confirm">Confirmar</button>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'

export default {
  components: {
    BaseModalBottom,
  },

  props: {
    title: {
      type: String,
      default: 'Validacão de segurança',
    },
  },

  data() {
    return {
      pixKey: {},
    }
  },

  methods: {
    open(pixKey) {
      this.pixKey = pixKey
      this.$refs.modal.open()
    },

    close() {
      this.$refs.modal.close()
    },

    confirm() {
      this.$emit('onConfirm')
      this.close()
    },

    cancel() {
      this.$emit('onCancel')
      this.close()
    },
  },
}
</script>

<style lang="scss">
.modal-pix-key-owner-confirmation {
  .title-message,
  .subtitle-message,
  strong {
    max-width: 429px;
    margin: 0 auto;
    font-size: 16px;
    color: $neutral;
  }

  .button-cancel {
    margin: 0 8px 16px 0;
  }
}
</style>
